export default __webpack_public_path__ + "static/media/nexgtv-entertainment-mobile-app-development.31742997.png";